import { atom } from 'jotai';

export interface IBannerInfo {
  show: boolean;
  type?: string;
}

export const $BannerInfo = atom<IBannerInfo>({
  show: false,
});
$BannerInfo.debugLabel = '$BannerInfo';
